import React, { useEffect, useLayoutEffect } from "react";
import {ErrorBoundary} from 'react-error-boundary'
import { useDispatch } from 'react-redux';
import OwnedAlbumsComponent from './components/owned_albums_component';
import SharedAlbumsComponent from "./components/shared_albums_component";
import AlbumsGearIconDropdown from '../common/albums_dropdown';
import Portal from '../common/portal';
import IConstants from "./meta/constants";
import { removeSelectedAlbumData } from "./meta/slices";
import { on } from "../../utils/events";
import intersectionObserverHandler from '../common/intersection_observer';
import { hideDropdownMenu } from "../../utils/common_utils";

/* global photoOrg */

const ErrorFallbackComponentForApp = ({error, resetErrorBoundary})=>{
    return null;
}

const LogRenderingError = (error, info)=>{
    photoOrg.clientLogger.error({description: "LIBRARY:AlbumView:myErrorHandler:Exception", errorCode: "LIBRARY:ALBUMS_VIEW", err_desc: error.message, err_stack: error.stack});
}


if(!photoOrg.ListenOnScrollEvent){
    photoOrg.ListenOnScrollEvent =  () => {
        hideDropdownMenu();
    } 
    photoOrg.listenOnBodyClickEvent =  (event) => {
        if(event.target.classList.contains("newdropdown") || event.target.classList.contains("sf-pointer") || (event.target.id && event.target.id.indexOf("ralb-gearicon")>-1)){
            return;
        }
        photoOrg.ListenOnScrollEvent();
    }
}

const AlbumsComponent = ({config: {albumsConfig, sortOrder}}) => {
    const dispatch = useDispatch();
    photoOrg.history.historyState.so = photoOrg.storage.getValueFromStorage("av_sortOrder",{addAccountId: true}) || 'ascending';
    photoOrg.history.historyState.sc = photoOrg.storage.getValueFromStorage("av_sortCriteria",{addAccountId: true}) || 'createDate';
    useLayoutEffect(()=>{
        intersectionObserverHandler.unobserve();
    },[])
    useEffect(()=>{
        const dispatchAction = (details) =>{
            dispatch(removeSelectedAlbumData(details.detail.albumId));
        }

        const emptyAlbumsSelectedObj = () =>{
            const deleteTotalSelectedAlbumsObj = true;
            dispatch(removeSelectedAlbumData(deleteTotalSelectedAlbumsObj));
        }
        on("rRemoveSelectedAlbumInfo", dispatchAction);
        on("rEmptyAlbumsSelectionState", emptyAlbumsSelectedObj);
        on('click', photoOrg.listenOnBodyClickEvent, document.getElementsByName("body")[0]);
        if(!photoOrg.photoLib.config.loadAsPhotoPicker){
            on("scroll", photoOrg.ListenOnScrollEvent,document.getElementById("right-well"));
        }
    },[])
   
    return (
        <ErrorBoundary FallbackComponent={ErrorFallbackComponentForApp} onError={LogRenderingError}>
            { 
                (albumsConfig.accessType === IConstants.OWNED) ?  
                <OwnedAlbumsComponent rid="OwnedAlbumsComponent" accessType={albumsConfig.accessType}></OwnedAlbumsComponent> :
                <SharedAlbumsComponent rid="SharedAlbumsComponent" sortOrder={sortOrder}  accessType={albumsConfig.accessType}></SharedAlbumsComponent>
            }
            {
                (!photoOrg.photoLib.config.loadAsPhotoPicker) ? 
                <Portal>
                    <AlbumsGearIconDropdown/>
                </Portal>
                : null
            }

     </ErrorBoundary>)
}

export default AlbumsComponent;